import React from "react";
import Select from "react-select";
import { THEME } from "../constants";

// react-select rather than the MUI Autocomplete used elsewhere on this page's
// toolbar: the property picker is the one control that names each store with
// its code, and react-select's option renderer does that without a portal.
const styles = {
  container: (base) => ({ ...base, width: "320px" }),
  control: (base, state) => ({
    ...base,
    minHeight: "40px",
    borderRadius: THEME.radius,
    borderColor: state.isFocused ? THEME.accent : THEME.line,
    boxShadow: "none",
    fontFamily: THEME.font,
    fontSize: "14px",
    ":hover": { borderColor: state.isFocused ? THEME.accent : "#C7D0E0" },
  }),
  placeholder: (base) => ({ ...base, color: THEME.muted, fontSize: "14px" }),
  menu: (base) => ({
    ...base,
    borderRadius: "12px",
    overflow: "hidden",
    fontFamily: THEME.font,
    zIndex: 20,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? THEME.accentTint
      : state.isFocused
        ? "#F5F7FF"
        : THEME.surface,
    color: THEME.ink,
    cursor: "pointer",
  }),
  singleValue: (base) => ({ ...base, color: THEME.ink, fontWeight: 600 }),
  indicatorSeparator: () => ({ display: "none" }),
};

const Option = ({ innerRef, innerProps, data, isSelected, isFocused }) => (
  <div
    ref={innerRef}
    {...innerProps}
    style={{
      padding: "8px 12px",
      cursor: "pointer",
      backgroundColor: isSelected
        ? THEME.accentTint
        : isFocused
          ? "#F5F7FF"
          : THEME.surface,
    }}
  >
    {/* The store code first, then the name, as wherever a store is named. */}
    <div style={{ fontSize: "14px", color: THEME.ink }}>
      {data.code && data.code !== data.label ? `${data.code} - ${data.label}` : data.label}
    </div>
  </div>
);

function PropertySelect({ properties, value, onChange, isLoading, onMenuOpen }) {
  // Typing a code has to find the row, so it is part of the searchable label.
  const options = properties.map((property) => ({
    value: property.houseAccessCode,
    label: property.houseName || property.houseAccessCode || "",
    code: property.houseAccessCode || "",
    property,
  }));

  const selected =
    options.find(
      (option) => option.value === value?.houseAccessCode
    ) || null;

  return (
    <Select
      options={options}
      value={selected}
      onChange={(option) => onChange(option ? option.property : null)}
      onMenuOpen={onMenuOpen}
      isLoading={isLoading}
      isClearable
      placeholder="Select a property..."
      noOptionsMessage={() => "No properties"}
      components={{ Option }}
      // The menu and the picked property both show the code before the name,
      // since two stores can share a name.
      formatOptionLabel={(option) =>
        option.code && option.code !== option.label
          ? `${option.code} - ${option.label}`
          : option.label
      }
      styles={styles}
      filterOption={(option, input) => {
        if (!input) return true;
        const text = input.toLowerCase();
        return (
          option.data.label.toLowerCase().includes(text) ||
          option.data.code.toLowerCase().includes(text)
        );
      }}
    />
  );
}

export default PropertySelect;
